import { render, staticRenderFns } from "./KgjtWebsiteGeneralInformationEdit.vue?vue&type=template&id=62d9ef2a&scoped=true&"
import script from "./KgjtWebsiteGeneralInformationEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteGeneralInformationEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteGeneralInformationEdit.vue?vue&type=style&index=0&id=62d9ef2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d9ef2a",
  null
  
)

export default component.exports